<template>
  <CContainer fluid>
    <CRow>
      <div>123</div>
    </CRow>
  </CContainer>
</template>

<script>


export default {

  components: {  },

  data () {
    return {

    }
  },

  mounted(){
  let person = prompt("Please enter your name", "Harry Potter");
  if (person != null) {
    document.getElementById("demo").innerHTML =
    "Hello " + person + "! How are you today?";
  }


  },


  methods: {

  }
}
</script>
